import React from "react";
import {
  Box,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import formatDate from "../helpers/formatDate";

export default function InfoGrid({ source, keyMap, columns=2 }) {
  return (
    <SimpleGrid columns={columns} spacing={2} p={1}>
      {
        Object.entries(keyMap).map(([key, val], i) => {
          const at_key = key + '_at';
          const by_key = key + '_by';
          return (
            <Box p={2} key={key + '-' + i}>
              <Text mb={1} fontSize={14} fontWeight={'bold'} borderBottomWidth={1}>{ val }</Text>
              { source[at_key] && <Text as="span" fontSize={12}>{ formatDate(source[at_key]) }</Text> }
              { source[at_key] && source[by_key] && <Text as="span">, </Text> }
              { source[by_key] && <Text as="span" fontSize={12}>{ source[by_key].first_name || source[by_key].username } tarafından</Text> }            </Box>
          )
        })
      }
    </SimpleGrid>
  )
}

